(ns quuppa.ui.spinner
  (:require
    ["react-bootstrap/Spinner" :default Spinner]))

(defn spinner [props]
  [:div.quuspinner.mx-2
   (merge {:style {"--color"  "var(--bs-primary)"}}
          props)
   [:span.visually-hidden "Loading"]])

(defn bootstrap-spinner [props]
  [:> Spinner props])
